import { gql } from "@apollo/client";

export const GET_ADVERTISE_BANNERS = gql`
  query GetAdvertiseBanners {
    advertiseBanners {
      id
      title
      imageUrl
      linkUrl
      description
      type
      authenticatedOnly
      organizerName
      organizerImage
      startDate
      expirationDate
    }
  }
`;
